import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

import parse from "html-react-parser";

const ErrorPopup = new Popup({
	title: function() {
		return this.get("title") || getLocaleString("errortitle");
	},
	style: {maxWidth: 500},
	render: function() {
		return (
			<>
				<div className="popup-internal-text">
					{parse(this.get("message"))}
				</div>
				<button onClick={() => _ui.closePopupOf(this)} style={{float: "right"}}>
					{getLocaleString("done")}
				</button>
			</>
		)
	}
});

export default ErrorPopup;